<template lang="pug">
  .dashboard
    #access(v-if="has_permission")
      .g-header-cont
        h2 {{ $t('strings.dashboard') }}
        span Welcome, {{ $auth.user().name }}
        br
      //- .g-cards-title Global Stats
      .g-cards-cont
        customer-infinite-list.min-width(v-if="$auth.check('Admin')" @click="setCustomerProjects")
        .step-cont
          stat-card.m-bottom(hex="#ED1B24" name="to-quotes" title="To Quote" :count="stats_to_quote.total" notAmount @click="clickedCard")
          recent-infinite-list-to-quote.spacing(title="Recent on To Quote" name="to_quote" :stage="1")
        .step-cont
          stat-card.m-bottom(hex="#4498E0" name="quotes" title="Quoted" :count="stats_quoted.total" :amount="stats_quoted.amount" @click="clickedCard")
          recent-infinite-list-quoted.spacing(title="Recent on Quoted" name="quoted" :stage="2")
        .step-cont
          stat-card.m-bottom(hex="#734B6D" name="in-orders" title="In Order" :count="stats_in_order.total" :amount="stats_in_order.amount" @click="clickedCard")
          simple-stat-card.spacing(:title="$t('projects.amount_due')" :amount="amount_due.in_order")
        .step-cont
          stat-card.m-bottom(hex="#3DCB6F" name="finished" title="Completed" :count="stats_finished.total" :amount="stats_finished.amount" @click="clickedCard")
          simple-stat-card.spacing(:title="$t('projects.amount_due')" :amount="amount_due.finished")
        .step-cont
          stat-card.m-bottom(hex="#FC7314" name="cancelled" title="Cancelled" :count="stats_cancelled.total" :amount="stats_cancelled.amount" @click="clickedCard")
          recent-infinite-list-cancelled.spacing(title="Recent on Cancelled" name="cancelled" :status="5")
    #no-access(v-else)
      access-denied
</template>

<script>
import { debounce } from '@/utils/debounce'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')

export default {
  name: 'dashboard',
  components: {
    SimpleStatCard: () => import('@/components/aditionals/SimpleStatCard.vue'),
    StatCard: () => import('@/components/aditionals/StatCard.vue'),
    CustomerInfiniteList: () => import('@/components/aditionals/CustomerInfiniteList.vue'),
    RecentInfiniteListToQuote: () => import('@/components/aditionals/RecentInfiniteListToQuote.vue'),
    RecentInfiniteListQuoted: () => import('@/components/aditionals/RecentInfiniteListQuoted.vue'),
    RecentInfiniteListCancelled: () => import('@/components/aditionals/RecentInfiniteListCancelled.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue')
  },
  data: () => ({
    selectedCard: 'projects',
    selectedCustomerId: undefined,
    has_permission: true
  }),
  async created () {
    this.checkPermissionView('dashboard.index')
    await this.loadDashboard()
    await this.loadProjectsDashboard()
  },
  beforeRouteLeave (to, from, next) {
    this.clearLists()
    next()
  },
  computed: {
    ...mapGetters([
      'stats_to_quote',
      'stats_quoted',
      'stats_cancelled',
      'stats_in_order',
      'stats_finished',
      'amount_due'
    ])
  },
  methods: {
    ...mapActions([
      'loadDashboard',
      'loadProjectsDashboard',
      'setCustomerIdDashboard',
      'loadProjectsCustomerDashboard',
      'loadCustomerDashboard',
      'clearLists',
      'clearProjects'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
    },
    clickedCard (cardName) {
      this.selectedCard = cardName
    },
    setCustomerProjects (customer) {
      if (customer && customer.id) {
        this.selectedCustomerId = customer.id
      } else {
        this.selectedCustomerId = undefined
        this.loadDashboard()
        this.loadProjectsDashboard()
      }
    }
  },
  watch: {
    selectedCustomerId:
      debounce(function (newId) {
        if (parseInt(newId) > 0) {
          this.loadProjectsCustomerDashboard({ customer_id: this.selectedCustomerId })
          this.loadCustomerDashboard({ customer_id: this.selectedCustomerId }).then(() => {
            this.clearProjects()
          })
        }
        this.setCustomerIdDashboard({ customer_id: this.selectedCustomerId })
      }, 500)
  }
}
</script>

<style scoped>
.dashboard {
  background-color: #fafafa;
  padding: 25px 45px;
}
.g-header-cont {
  margin-bottom: 15px;
}
.g-cards-title {
  font-size: 1rem;
}
.g-cards-cont {
  display: flex;
  align-items: top;
}
.step-cont {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.m-bottom {
  margin-bottom: 20px;
}
.spacing {
  margin: 8px;
}
.min-width {
  min-width: 200px;
}
</style>
